import { QCalculateBets } from "./QCalculateBets";
import { QPlaceBets } from "./QPlaceBets";
import { QUpdatePurchases } from "./QUpdatePurchases";
import { QGetPurchases } from "./QGetPurchases";
export const QueryBuilder = {
    calculateBets: QCalculateBets,
    placeBets: QPlaceBets,
    updatePurchases: QUpdatePurchases,
    getPurchases: QGetPurchases
};
//# sourceMappingURL=index.js.map